import type { FC, ReactNode } from "react";
import { createPortal } from "react-dom";
import { useMediaQuery, useTheme } from "@mui/material";

interface PlayerOverlaySlotProps {
  /** Элемент мобильного слота под плеером (StreamScreen/VideoScreen). */
  mobileSlot: HTMLElement | null;
  children: ReactNode;
}

/**
 * Панель реакций и карточка опроса: на десктопе поверх кадра, на мобайле
 * в слоте под плеером (отдельной зоны под плеером на мобайле нет, её
 * добавляют экраны). Пока слот не смонтирован, на мобайле не рисуем
 * ничего, а не падаем в кадр.
 */
export const PlayerOverlaySlot: FC<PlayerOverlaySlotProps> = ({
  mobileSlot,
  children,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  if (!isMobile) return <>{children}</>;
  return mobileSlot ? createPortal(children, mobileSlot) : null;
};
